import { useEffect } from "react";
import { observer } from "mobx-react-lite";
import Link from './Link';
//import useIdentity from "../hooks/useIdentity";
import useMutual from "../hooks/useMutual";
import useUserIdentity from "../hooks/useUserIdentity";
import { Mutual } from "../stores/mutual_store";
import IdentityAvatar from "./IdentityAvatar";

import Stack from '@mui/joy/Stack';
import Tooltip from '@mui/joy/Tooltip';

import Divider from '@mui/joy/Divider';
import Typography from '@mui/joy/Typography';
// import DateUI from './Date';
import { pluralize } from 'utils/misc';
import useDedicatedAssignment from "hooks/useDedicatedAssignment";

type MutualComponentProps = {
    mutual?: Mutual,
    identityKey: string
}

export const MutualsListComponent = observer(( { identityKey } : MutualComponentProps) => {

    return (
        <Link to={`/identity/${identityKey}`}>
            <Stack padding={1}>
                <IdentityAvatar
                    interactive={false}
                    size="inline"
                    level="body-xs"
                    identityKey={identityKey} />
            </Stack>
        </Link>
    );

});

const MutualsList = observer(( { identityKey, showTitle=true, hideDedicated=false } : { identityKey: string, showTitle?: boolean, hideDedicated?: boolean  }) => {
    const { getMutualsList, fetchMutualsList } = useMutual();
    const { currentIdentity } = useUserIdentity();
    const { isYou } = useUserIdentity();
    const { isDedicatedFor } = useDedicatedAssignment();

    const mutuals = getMutualsList(identityKey);

    useEffect(() => {
        fetchMutualsList(identityKey);
    }, [fetchMutualsList, identityKey]);

    return (
        <Stack spacing={1}>
            {showTitle &&
                <Stack>
                    {isYou(identityKey) ? (
                        <Typography level="title-lg">
                            Your Team
                        </Typography>
                    ) : (
                        <Tooltip arrow placement="top" title="This person's mutuals list.">
                            <Typography level="title-lg">
                                Following
                                <Typography pl={1} level="body-sm">(Their Day Ones)
                                </Typography>
                            </Typography>
                        </Tooltip>
                    )}
                </Stack>
            }

            <Stack
                divider={<Divider />} >
                {mutuals.filter((m) => !hideDedicated || !isDedicatedFor(m.mutual_identity, currentIdentity.key)).map((mutual) => {
                    return (
                        <MutualsListComponent
                            key={mutual.key}
                            mutual={mutual}
                            identityKey={mutual.mutual_identity} />
                    );
                })}
            </Stack>
        </Stack>
    );

});

export const MutualsListed = observer(({ identityKey }: { identityKey: string }) => {
    const { getMutualsListed, fetchMutualsListed } = useMutual();
    const mutuals = getMutualsListed(identityKey);

    useEffect(() => {
        fetchMutualsListed(identityKey);
    }, [fetchMutualsListed, identityKey]);

    return (
        <Stack>
            <Tooltip arrow placement="top" title="People who follow this person ">
                <Typography level="title-lg">
                    {pluralize(mutuals.length, 'Follower')}
                </Typography>
            </Tooltip>
            <Stack
                divider={<Divider />} >
                {mutuals.map((mutual) => {
                    return (
                        <MutualsListComponent
                            key={mutual.key}
                            mutual={mutual}
                            identityKey={mutual.identity} />
                    );
                })}
            </Stack>
        </Stack>
    );
});
export default MutualsList;
